import { HTTP_CP_MortgageCase, HTTP_CP_SmartSearchCase } from '@api-new/caseservice';
import { ENUM_MortgageCaseStatus, ENUM_SmartSearchCaseStatus } from '@api-new/common';
import { CasePreviewCardModel } from '@platform/property/models/case-preview-card.model';
import { CasePreviewCardTypeEnum } from '@shared/enums/case-preview-card-type.enum';
import { OpenCaseTypeEnum } from '@shared/enums/open-case-type.enum';

export const portfolioCasePreviewCardAdapter = (
  itemCase: HTTP_CP_MortgageCase | HTTP_CP_SmartSearchCase,
  numberOfDeals = 0,
): CasePreviewCardModel => ({
  type: setCasePreviewCardType(numberOfDeals, itemCase),
  numberOfDeals,
  openCaseType: setCasePreviewCardOpenCaseType(itemCase),
  caseId: itemCase?.id,
});

const setCasePreviewCardType = (
  numberOfBestDeals: number,
  itemCase: HTTP_CP_MortgageCase | HTTP_CP_SmartSearchCase,
): CasePreviewCardTypeEnum => {
  if (itemCase) return CasePreviewCardTypeEnum.CaseOpened;
  if (numberOfBestDeals) return CasePreviewCardTypeEnum.HasDeal;
  return CasePreviewCardTypeEnum.NoDeal;
};

const setCasePreviewCardOpenCaseType = (itemCase: Partial<HTTP_CP_MortgageCase & HTTP_CP_SmartSearchCase>): OpenCaseTypeEnum => {
  if (!itemCase) return null;
  if (itemCase.mortgageCaseStatus === ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_PIPELINE) return OpenCaseTypeEnum.Active;
  if (itemCase.smartSearchCaseStatus === ENUM_SmartSearchCaseStatus.SMART_SEARCH_CASE_STATUS_PIPELINE) return OpenCaseTypeEnum.Active;
  return OpenCaseTypeEnum.Lead;
};
